export default __webpack_public_path__ + "img/stats_modal.8426c56c.png";